var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoDesplegableUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.82 25.82",
    style: {
      enableBackground: "new 0 0 25.82 25.82"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-arrow-dropdown",
    transform: "translate(25.823 25.823) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3554",
    d: "M6.18,10.1c-0.47,0.47-0.47,1.23,0,1.69l5.94,5.92c0.45,0.45,1.18,0.47,1.65,0.04l5.85-5.84 c0.51-0.43,0.57-1.19,0.14-1.69s-1.19-0.57-1.69-0.14c-0.05,0.04-0.1,0.09-0.14,0.14l-5.03,4.95l-5.03-5.08 C7.41,9.63,6.65,9.63,6.18,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3555",
    d: "M0,12.91c0,7.13,5.78,12.91,12.91,12.91s12.91-5.78,12.91-12.91S20.04,0,12.91,0 c0,0,0,0,0,0C5.78,0,0,5.78,0,12.91C0,12.91,0,12.91,0,12.91z M20.63,5.19c4.3,4.23,4.37,11.14,0.14,15.44S9.63,25,5.33,20.77 c-0.05-0.05-0.09-0.09-0.14-0.14C0.89,16.41,0.82,9.49,5.05,5.19s11.14-4.37,15.44-0.14C20.54,5.1,20.59,5.14,20.63,5.19z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDesplegableUp);
export default __webpack_public_path__ + "static/media/icono-desplegable-up.d84ac17eaabc66dbc37df486163d2e01.svg";
export { ForwardRef as ReactComponent };